import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var checkboxLabel = createRuntimeFn({defaultClassName:'label_checkboxLabel__1bn7u9q1',variantClassNames:{size:{xsmall:'label_checkboxLabel_size_xsmall__1bn7u9q2',small:'label_checkboxLabel_size_small__1bn7u9q3','default':'label_checkboxLabel_size_default__1bn7u9q4'}},defaultVariants:{size:'default'},compoundVariants:[]});
var checkboxLabelHorizontalGap = 'var(--checkbox-label-horizontal-gap__1bn7u9q0)';

export { checkboxLabel, checkboxLabelHorizontalGap };
//# sourceMappingURL=label.vanilla.mjs.map
